import { CardIcon } from '@ampol/design-system';
import { useState } from 'react';
import AmpolCardFallback from 'assets/AmpolCardFallback.png';
import useCardImageModal from './useCardImageModal';
import { useSelectAccountDefaultsLoading, useSelectPlasticType } from 'selectors/selectors';

export default function CardModalIcon() {
  const accountDefaultsLoading = useSelectAccountDefaultsLoading();
  const plasticType = useSelectPlasticType();
  const cardDetailsModal = useCardImageModal();

  const [fallBackImage, setFallbackImage] = useState<string>(null);

  if (accountDefaultsLoading || !plasticType?.image.url)
    return (
      <>
        <CardIcon
          className='card-form-modal--icon -mr-[48px] animate-pulse pointer-events-none'
          url={AmpolCardFallback}
        />
      </>
    );

  return (
    <CardIcon
      className='card-form-modal--icon -mr-[48px]'
      url={fallBackImage ?? plasticType?.image?.url}
      onClick={cardDetailsModal.open}
      attributes={{
        onError: () => {
          console.log('Error loading plastic card image');
          setFallbackImage(AmpolCardFallback);
        },
      }}
    />
  );
}
